import React, { forwardRef } from 'react';

const InputField = forwardRef(({ label, ...props }, ref) => (
  <div>
    <label className="block text-sm font-medium text-gray-300 mb-1.5">{label}</label>
    <input {...props} ref={ref} className="w-full p-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-amber-500" />
  </div>
));

export default InputField;